import { Option } from "./option.model";

export class SingleChoiceQuestion {
    text: string = "";
    explanation: string = "";
    options: Option[] = [];

    _i18n?: Record<string, Record<string, string>>;

    constructor(text: string, explanation: string, options: Option[]) {
        this.text = text;
        this.explanation = explanation;
        this.options = options;
    }
}
